import React from 'react';
import {API} from '../../../constants';
import './Hero.scss';
import PageDescription from "../PageDescription";
import LazyLoadImage from '../../atoms/image/Image';

const Hero = ({data}) => {   
  const { id, object } = data || {};
  const { image, pageDescription } = object[0] || {};

  const { Desktop, Mobile, altText } = image || {};

  return (data &&
    <div id = { id } className='hero' role="banner">
      <div className='container mx-auto h-full flex flex-wrap md:items-start px-5 md:px-20 hero-wrapper survey-container'>
          <div role="figure" aria-labelledby={altText} className="w-full md:w-1/2 order-first md:order-2 hero">
            <picture>
              <source media="(min-width:768px)" srcSet={`${API}/images/${Desktop}`}/>
              <source media="(min-width:767px)" srcSet={`${API}/images/${Mobile}`}/>
              <LazyLoadImage role="img" aria-label={altText} src={`${API}/images/${Desktop}`} alt={altText}/>
            </picture>
          </div>

          <PageDescription data = { pageDescription }/>
          
      </div>
    </div>  
  )
}

export default Hero;